import { FeatureFlagsEnum } from '@/shared/api/types/raw-web-sales-responses/FeatureFlags.ts';
import { persistedFeatureFlagsAccessor } from '@stores/webStorages/storages/PersistedFeatureFlags.accessor.ts';

/**
 * Read synchronously from persisted (sessionStorage) flags: instances are created at
 * store-construction time, before the flags API resolves. Stable within a page load.
 */
export const IS_SHARED_FETCH_STATE_ENABLED =
  persistedFeatureFlagsAccessor.getPersistedFlags()?.[FeatureFlagsEnum.SharedFetchState] ?? false;
